import { render } from "./HelloWorld.vue?vue&type=template&id=64c5a022&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=64c5a022&scoped=true&lang=scss"

import exportComponent from "D:\\phpStudy\\WWW\\WeCom\\enterprise-wechat---test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c5a022"]])

export default __exports__